import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import SchemaMarkup from "./SchemaMarkup";
import H1 from "./elements/H1";
import H2 from "./elements/H2";
import Paragraph from "./elements/Paragraph";
import ImageBlock from "./elements/ImageBlock";
import Buttons from "./elements/Buttons";
import config from "../config";

const componentMap = {
  h1: H1,
  h2: H2,
  paragraph: Paragraph,
  image: ImageBlock,
  buttons: Buttons,
};

export default function PageRenderer({ data }) {
  const location = useLocation();
  if (!data || !data.blocks) return null;

  return (
    <main>
      <article>
        <Helmet>
          <title>{data.title}</title>
          <meta name="description" content={data.description} />

          {/* Canonical */}
          <link rel="canonical" href={config.siteUrl + location.pathname} />

          {/* Open Graph */}
          <meta property="og:title" content={data.title} />
          <meta property="og:description" content={data.description} />
          <meta
            property="og:image"
            content={config.siteUrl + "/images/logo.png"}
          />
          <meta property="og:image:width" content="512" />
          <meta property="og:image:height" content="512" />
          <meta
            property="og:url"
            content={config.siteUrl + location.pathname}
          />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={config.brandName} />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={data.title} />
          <meta name="twitter:description" content={data.description} />
          <meta
            name="twitter:image"
            content={config.siteUrl + "/images/logo.png"}
          />
          <meta
            name="twitter:url"
            content={config.siteUrl + location.pathname}
          />
        </Helmet>

        <SchemaMarkup data={data} />

        {data.blocks.map((block, i) => (
          <section
            key={i}
            className={i === 0 ? "banner-sec" : "sectionContent"}
          >
            <div className="contentBlock">
              {block.elements.map((el, j) => {
                const Component = componentMap[el.type];
                if (!Component) return null;
                return <Component key={j} {...el} />;
              })}
            </div>
          </section>
        ))}
      </article>
    </main>
  );
}
